import React from "react";
import { useDispatch } from "react-redux";
import {
  deleteSubjectStart,
  getAllSubjectStart,
} from "../../../redux/subject/reducer";

import styled from "styled-components";
import { Text, DropDown } from "@flexisaf/flexibull2";
import Theme, { Colors } from "../../../theme";

const SubjectCard = ({
  name,
  id,
  handleEdit,
  curriculum,
  desc,
  handleTopicView,
}) => {
  const dispatch = useDispatch();
  const handleDelete = (id) => {
    dispatch(
      deleteSubjectStart({
        id,
        cb: () => {
          dispatch(getAllSubjectStart());
        },
      })
    );
  };
  return (
    <SubjectCardContainer>
      <div className="card-header">
        <Text color={Colors.Grey700} style={{ fontWeight: 500 }}>
          {" "}
          <i
            className="saf-category-2"
            style={{ marginRight: "5px", color: `${Theme.PrimaryColor}` }}
          />
          {name}
        </Text>

        <DropDown
          label={
            <Text bold size="14px" style={{ cursor: "pointer" }}>
              ...
            </Text>
          }
          menuAlign="bottom right"
          trigger="click"
          menuList={[
            {
              onClick: () => handleTopicView(name),
              label: "View Topics",
              iconLeft: "saf-document",
            },
            {
              onClick: () => handleEdit(id, name, curriculum, desc),
              label: "Edit Subject",
              iconLeft: "saf-receipt-edit",
            },
            {
              onClick: () => handleDelete(id),
              label: "Delete Subject",
              color: Theme.PrimaryRed,
              iconLeft: "saf-trash",
            },
          ]}
        />
      </div>

      <div className="card-body">
        <Text block size="12px">
          Description
        </Text>
        <Text size="11px" color={Theme.PrimaryGrey}>
          {desc || "No description provided for this subject"}
        </Text>
      </div>
    </SubjectCardContainer>
  );
};

export default SubjectCard;

const SubjectCardContainer = styled.div`
  background: #f1f1f17d;
  border-radius: 8px;
  overflow: hidden;

  & .card-header {
    background: #fff;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: space-between;
    padding: 1rem 1rem;
    & img {
      border-radius: 50%;
      width: 50px;
      height: 50px;
    }
    & .exam-title {
      p:first-of-type {
        font-size: 1rem;
      }
    }
  }
  & .card-body {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
    /* justify-content: space-evenly; */
    /* align-items: center; */
    padding: 2rem 1rem;
    height: 10rem;
    /* margin-top: 2rem; */
    & p > span {
      font-weight: bold;
    }
  }
  & .card-footer {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    gap: 2rem;
    padding: 1rem 0;
  }
  & .topics {
    padding: 0.5rem 1rem;
  }
`;
